
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1lkep", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd44d1de16eeada$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1fKJk = parcelRequire("1fKJk");

var $bFtEE = parcelRequire("bFtEE");

var $aABH4 = parcelRequire("aABH4");

var $hAs1r = parcelRequire("hAs1r");

var $1VG19 = parcelRequire("1VG19");

var $hibqv = parcelRequire("hibqv");

var $f5KSA = parcelRequire("f5KSA");
var $eaR7m = parcelRequire("eaR7m");
var $5AmZK = parcelRequire("5AmZK");
var $fIRKG = parcelRequire("fIRKG");
var $j9muy = parcelRequire("j9muy");

var $iHYdz = parcelRequire("iHYdz");

var $bL5sD = parcelRequire("bL5sD");

var $VSDnB = parcelRequire("VSDnB");
function $ddd44d1de16eeada$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $ddd44d1de16eeada$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $iHYdz.akEditorCustomIconSize)) / 2;
const $ddd44d1de16eeada$var$panelEmojiImageVerticalAlignment = $ddd44d1de16eeada$var$panelEmojiSpriteVerticalAlignment - 1;
const $ddd44d1de16eeada$var$blockNodesVerticalMargin = '0.75rem';
const $ddd44d1de16eeada$var$akEditorTableCellMinWidth = 48;
const $ddd44d1de16eeada$var$panelBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-panel': {
        borderRadius: "var(--ds-border-radius, 3px)",
        margin: `${$ddd44d1de16eeada$var$blockNodesVerticalMargin} 0 0`,
        paddingTop: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-200, 16px)",
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-100, 8px)",
        minWidth: `${$ddd44d1de16eeada$var$akEditorTableCellMinWidth}px`,
        display: 'flex',
        position: 'relative',
        alignItems: 'normal',
        wordBreak: 'break-word',
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #DEEBFF)",
        color: 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__icon': {
            flexShrink: 0,
            height: "var(--ds-space-300, 24px)",
            width: "var(--ds-space-300, 24px)",
            boxSizing: 'content-box',
            paddingRight: "var(--ds-space-100, 8px)",
            textAlign: 'center',
            userSelect: 'none',
            MozUserSelect: 'none',
            WebkitUserSelect: 'none',
            MsUserSelect: 'none',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '0.1em',
            color: "var(--ds-icon-information, #1D7AFC)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span': {
                verticalAlign: 'middle',
                display: 'inline-flex'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-sprite': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$ddd44d1de16eeada$var$panelEmojiSpriteVerticalAlignment}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-image': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$ddd44d1de16eeada$var$panelEmojiImageVerticalAlignment}px`,
                // Vertical align only works for inline-block elements in Firefox
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '@-moz-document url-prefix()': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    img: {
                        display: 'inline-block'
                    }
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
            flex: '1 0 0',
            /*
      https://ishadeed.com/article/min-max-css/#setting-min-width-to-zero-with-flexbox
      The default value for min-width is auto, which is computed to zero. When an element is a flex item, the value of min-width doesn’t compute to zero. The minimum size of a flex item is equal to the size of its contents.
      */ minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="note"]': {
            backgroundColor: "var(--ds-background-accent-purple-subtlest, #EAE6FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-discovery, #8270DB)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="tip"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #E3FCEF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #22A06B)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="warning"]': {
            backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-warning, #E56910)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="error"]': {
            backgroundColor: "var(--ds-background-accent-red-subtlest, #FFEBE6)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-danger, #C9372C)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="success"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #E3FCEF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #22A06B)"
            }
        }
    }
});
const $ddd44d1de16eeada$var$panelHasNoIconStyles = {
    name: "vaqcwq",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}}"
};
const $ddd44d1de16eeada$var$panelNestedIconStyles = {
    name: "dsr7j7",
    styles: "&.ak-editor-panel__no-icon{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}"
};
const $ddd44d1de16eeada$var$panelCustomBackground = {
    name: "bjtns3",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{background-color:var(--ak-renderer-panel-custom-bg-color);}}"
};
const $ddd44d1de16eeada$var$PanelStyledOld = ({ backgroundColor: backgroundColor, hasIcon: hasIcon, ...props })=>{
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- nested css mixins are violations
    let styles = /*#__PURE__*/ (0, $f8Sb3.css)("&.", (0, $aABH4.PanelSharedCssClassName).prefix, "{", (0, $aABH4.panelSharedStylesWithoutPrefix)(), " &[data-panel-type=", (0, $bFtEE.PanelType).CUSTOM, "]{", hasIcon ? '' : 'padding-left: 12px;padding-right: 12px;', ";}}");
    if (props['data-panel-type'] === (0, $bFtEE.PanelType).CUSTOM && backgroundColor) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- nested css mixins are violations
    styles = /*#__PURE__*/ (0, $f8Sb3.css)("&.", (0, $aABH4.PanelSharedCssClassName).prefix, "{", (0, $aABH4.panelSharedStylesWithoutPrefix)(), ";}&[data-panel-type=", (0, $bFtEE.PanelType).CUSTOM, "]{background-color:", (0, $hAs1r.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor, ";", hasIcon ? '' : 'padding-left: 12px;padding-right: 12px;', ";}");
    return(// eslint-disable-next-line
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles,
        ...props
    }, props.children));
};
const $ddd44d1de16eeada$var$PanelStyledNew = ({ backgroundColor: backgroundColor, hasIcon: hasIcon, ...props })=>{
    const customBackgroundColor = backgroundColor ? (0, $hAs1r.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        {
            '--ak-renderer-panel-custom-bg-color': customBackgroundColor
        },
        css: [
            $ddd44d1de16eeada$var$panelBaseStyles,
            !hasIcon && $ddd44d1de16eeada$var$panelHasNoIconStyles,
            props['data-panel-type'] === (0, $bFtEE.PanelType).CUSTOM && backgroundColor && $ddd44d1de16eeada$var$panelCustomBackground,
            (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && $ddd44d1de16eeada$var$panelNestedIconStyles
        ],
        ...props
    }, props.children);
};
const $ddd44d1de16eeada$var$PanelStyled = (0, $bL5sD.componentWithFG)('platform_editor_emotion_refactor_renderer', $ddd44d1de16eeada$var$PanelStyledNew, $ddd44d1de16eeada$var$PanelStyledOld);
$ddd44d1de16eeada$var$PanelStyled.displayName = 'PanelStyled';
const $ddd44d1de16eeada$var$panelIcons = {
    info: (0, $eaR7m.PanelInfoIcon),
    success: (0, $fIRKG.PanelSuccessIcon),
    note: (0, $5AmZK.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($1fKJk))),
    warning: (0, $j9muy.PanelWarningIcon),
    error: (0, $f5KSA.PanelErrorIcon),
    custom: (0, (/*@__PURE__*/$parcel$interopDefault($1VG19)))
};
const $ddd44d1de16eeada$var$Panel = (props)=>{
    const { allowCustomPanels: allowCustomPanels, panelType: type, panelColor: panelColor, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText, providers: providers, children: children } = props;
    // only allow custom panel type if flag is set
    // otherwise fall back to info if custom panel is given
    const panelType = allowCustomPanels ? type : type === (0, $bFtEE.PanelType).CUSTOM ? (0, $bFtEE.PanelType).INFO : type;
    const getIcon = ()=>{
        if (panelType === (0, $bFtEE.PanelType).CUSTOM) {
            if (panelIcon && providers) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hibqv.default), {
                id: panelIconId,
                text: panelIconText,
                shortName: panelIcon,
                providers: providers
            });
            return null;
        }
        const Icon = $ddd44d1de16eeada$var$panelIcons[panelType];
        return /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, {
            label: `${panelType} panel`
        });
    };
    const icon = getIcon();
    const renderIcon = ()=>{
        if (icon) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            className: (0, $aABH4.PanelSharedCssClassName).icon
        }, icon);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($ddd44d1de16eeada$var$PanelStyled, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $aABH4.PanelSharedCssClassName).prefix,
        "data-panel-type": panelType,
        "data-panel-color": panelColor,
        "data-panel-icon": panelIcon,
        "data-panel-icon-id": panelIconId,
        "data-panel-icon-text": panelIconText,
        backgroundColor: panelColor,
        hasIcon: Boolean(icon)
    }, renderIcon(), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $aABH4.PanelSharedCssClassName).content
    }, children));
};
var $ddd44d1de16eeada$export$2e2bcd8739ae039 = $ddd44d1de16eeada$var$Panel;

});
parcelRegister("1fKJk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b2d7d7d35471a6e12918268c6980291>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e9b70cb22fca5c7$var$_react = $0e9b70cb22fca5c7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e9b70cb22fca5c7$var$_lightbulb = $0e9b70cb22fca5c7$var$_interopRequireDefault((parcelRequire("e78BF")));

var $0e9b70cb22fca5c7$var$_hint = $0e9b70cb22fca5c7$var$_interopRequireDefault((parcelRequire("3LPB1")));
function $0e9b70cb22fca5c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LightbulbIcon.
 * This component is LightbulbIcon, with `UNSAFE_fallbackIcon` set to "EditorHintIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e9b70cb22fca5c7$var$LightbulbIcon = (props)=>/*#__PURE__*/ $0e9b70cb22fca5c7$var$_react.default.createElement($0e9b70cb22fca5c7$var$_lightbulb.default, Object.assign({
        LEGACY_fallbackIcon: $0e9b70cb22fca5c7$var$_hint.default
    }, props));
$0e9b70cb22fca5c7$var$LightbulbIcon.Name = 'LightbulbIconMigration';
var $0e9b70cb22fca5c7$var$_default = module.exports.default = $0e9b70cb22fca5c7$var$LightbulbIcon;

});
parcelRegister("3LPB1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bedc8cbbdb04211$var$_react = $2bedc8cbbdb04211$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2bedc8cbbdb04211$var$_lightbulb = $2bedc8cbbdb04211$var$_interopRequireDefault((parcelRequire("e78BF")));
function $2bedc8cbbdb04211$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bedc8cbbdb04211$var$EditorHintIcon = (props)=>/*#__PURE__*/ $2bedc8cbbdb04211$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14 16h-4s0-.5-1-2-2.5-3-2.5-5S7 4 12 4s5.5 3 5.5 5-1.5 3.5-2.5 5-1 2-1 2m-4 1h4v1l-1.5 2h-1L10 18z"/></svg>`
    }, props, {
        newIcon: $2bedc8cbbdb04211$var$_lightbulb.default
    }));
$2bedc8cbbdb04211$var$EditorHintIcon.displayName = 'EditorHintIcon';
var $2bedc8cbbdb04211$var$_default = module.exports.default = $2bedc8cbbdb04211$var$EditorHintIcon;

});


parcelRegister("aABH4", function(module, exports) {

$parcel$export(module.exports, "darkPanelColors", () => $c61dedcc3b2bdafe$export$804476272fbaff5e);
$parcel$export(module.exports, "PanelSharedCssClassName", () => $c61dedcc3b2bdafe$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $c61dedcc3b2bdafe$export$8099afddf1b1be78);
$parcel$export(module.exports, "panelSharedStylesWithoutPrefix", () => $c61dedcc3b2bdafe$export$d707b378cb63679a);
$parcel$export(module.exports, "panelSharedStyles", () => $c61dedcc3b2bdafe$export$fc98407afe711ba8);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bFtEE = parcelRequire("bFtEE");

var $hAs1r = parcelRequire("hAs1r");

var $iHYdz = parcelRequire("iHYdz");

var $iHYdz = parcelRequire("iHYdz");


var $VSDnB = parcelRequire("VSDnB");
const $c61dedcc3b2bdafe$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $c61dedcc3b2bdafe$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
const $c61dedcc3b2bdafe$var$lightIconColor = {
    info: "var(--ds-icon-information, #1D7AFC)",
    note: "var(--ds-icon-discovery, #8270DB)",
    tip: "var(--ds-icon-success, #22A06B)",
    success: "var(--ds-icon-success, #22A06B)",
    warning: "var(--ds-icon-warning, #E56910)",
    error: "var(--ds-icon-danger, #C9372C)"
};
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $iHYdz.akEditorCustomIconSize)) / 2;
const $c61dedcc3b2bdafe$var$panelEmojiImageVerticalAlignment = $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment - 1;
function $c61dedcc3b2bdafe$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$c61dedcc3b2bdafe$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $c61dedcc3b2bdafe$var$prefix = 'ak-editor-panel';
const $c61dedcc3b2bdafe$export$6dd740b6c888e050 = {
    prefix: $c61dedcc3b2bdafe$var$prefix,
    content: `${$c61dedcc3b2bdafe$var$prefix}__content`,
    icon: `${$c61dedcc3b2bdafe$var$prefix}__icon`,
    noIcon: `${$c61dedcc3b2bdafe$var$prefix}__no-icon`
};
const $c61dedcc3b2bdafe$export$b0ee08fae091706a = {
    infoPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).INFO}]`,
    notePanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).NOTE}]`,
    warningPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).WARNING}]`,
    errorPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).ERROR}]`,
    successPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $c61dedcc3b2bdafe$var$getIconStyles = (panelType)=>{
    if ((0, $VSDnB.fg)('platform_editor_lcm_nested_panel_icon_fix')) return `
			.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.icon}[data-panel-type='${panelType}'] {
				color: ${$c61dedcc3b2bdafe$var$lightIconColor[panelType]};
			}
		`;
    else return `
			.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.icon} {
				color: ${$c61dedcc3b2bdafe$var$lightIconColor[panelType]};
			}
		`;
};
const $c61dedcc3b2bdafe$export$8099afddf1b1be78 = (panelType)=>$c61dedcc3b2bdafe$var$lightPanelColors[panelType] || 'none';
const $c61dedcc3b2bdafe$export$dd3f0fd482ae7ccc = (panelType)=>(0, $hAs1r.hexToEditorBackgroundPaletteColor)($c61dedcc3b2bdafe$var$lightPanelColors[panelType]) || 'none';
const $c61dedcc3b2bdafe$var$mainDynamicStyles = (panelType)=>{
    return `
    background-color: ${$c61dedcc3b2bdafe$export$dd3f0fd482ae7ccc(panelType)};
    color: inherit;
  `;
};
const $c61dedcc3b2bdafe$export$d707b378cb63679a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("border-radius:var(--ds-border-radius, 3px);margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0;padding-top:var(--ds-space-100, 8px);padding-right:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-100, 8px);padding-left:var(--ds-space-100, 8px);min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;display:flex;position:relative;align-items:normal;word-break:break-word;", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).INFO), " .", $c61dedcc3b2bdafe$export$6dd740b6c888e050.icon, "{flex-shrink:0;height:var(--ds-space-300, 24px);width:var(--ds-space-300, 24px);box-sizing:content-box;padding-right:var(--ds-space-100, 8px);text-align:center;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;margin-top:0.1em;>span{vertical-align:middle;display:inline-flex;}.", (0, $63856011855bb785$export$1c10634420a08d8a), "{vertical-align:", $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment, "px;}.", (0, $63856011855bb785$export$da61cef1c8919f7c), "{vertical-align:", $c61dedcc3b2bdafe$var$panelEmojiImageVerticalAlignment, "px;@-moz-document url-prefix(){img{display:inline-block;}}}}.ak-editor-panel__content{margin:var(--ds-space-025, 2px) 0 var(--ds-space-025, 2px);flex:1 0 0;min-width:0;}&[data-panel-type='", (0, $bFtEE.PanelType).INFO, "']{", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).INFO), ";}&[data-panel-type='", (0, $bFtEE.PanelType).NOTE, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).NOTE), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).NOTE), ";}&[data-panel-type='", (0, $bFtEE.PanelType).TIP, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).TIP), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).TIP), ";}&[data-panel-type='", (0, $bFtEE.PanelType).WARNING, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).WARNING), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).WARNING), ";}&[data-panel-type='", (0, $bFtEE.PanelType).ERROR, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).ERROR), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).ERROR), ";}&[data-panel-type='", (0, $bFtEE.PanelType).SUCCESS, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).SUCCESS), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).SUCCESS), ";}", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? `&.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}` : '', ";");
const $c61dedcc3b2bdafe$export$fc98407afe711ba8 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.prefix}`]: $c61dedcc3b2bdafe$export$d707b378cb63679a()
    });

});
const $63856011855bb785$export$8633a0edef8e95dd = 'emoji-common-selected';
const $63856011855bb785$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $63856011855bb785$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $63856011855bb785$export$b06c4aab1d012063 = 'emoji-common-node';
const $63856011855bb785$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $63856011855bb785$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $63856011855bb785$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $63856011855bb785$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $63856011855bb785$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $63856011855bb785$export$b0fe756d87022806 = 'emoji-picker-add-emoji';


parcelRegister("1VG19", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be2db0d473b67ee2b7dfc80ce4f694c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $167bb52569d93b17$var$_react = $167bb52569d93b17$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $167bb52569d93b17$var$_emoji = $167bb52569d93b17$var$_interopRequireDefault((parcelRequire("cVLny")));

var $167bb52569d93b17$var$_emoji2 = $167bb52569d93b17$var$_interopRequireDefault((parcelRequire("5KHlT")));
function $167bb52569d93b17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiIcon.
 * This component is EmojiIcon, with `UNSAFE_fallbackIcon` set to "EditorEmojiIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $167bb52569d93b17$var$EmojiIcon = (props)=>/*#__PURE__*/ $167bb52569d93b17$var$_react.default.createElement($167bb52569d93b17$var$_emoji.default, Object.assign({
        LEGACY_fallbackIcon: $167bb52569d93b17$var$_emoji2.default
    }, props));
$167bb52569d93b17$var$EmojiIcon.Name = 'EmojiIconMigration';
var $167bb52569d93b17$var$_default = module.exports.default = $167bb52569d93b17$var$EmojiIcon;

});
parcelRegister("cVLny", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $969f8f5da972f70f$var$_react = $969f8f5da972f70f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $969f8f5da972f70f$var$_baseNew = $969f8f5da972f70f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $969f8f5da972f70f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $969f8f5da972f70f$var$EmojiIcon = (props)=>/*#__PURE__*/ $969f8f5da972f70f$var$_react.default.createElement($969f8f5da972f70f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$969f8f5da972f70f$var$EmojiIcon.displayName = 'EmojiIcon';
var $969f8f5da972f70f$var$_default = module.exports.default = $969f8f5da972f70f$var$EmojiIcon;

});

parcelRegister("5KHlT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4302e071af14b636$var$_react = $4302e071af14b636$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4302e071af14b636$var$_emoji = $4302e071af14b636$var$_interopRequireDefault((parcelRequire("cVLny")));
function $4302e071af14b636$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4302e071af14b636$var$EditorEmojiIcon = (props)=>/*#__PURE__*/ $4302e071af14b636$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 12.5c3.033 0 5.5-2.467 5.5-5.5S15.033 6.5 12 6.5A5.506 5.506 0 0 0 6.5 12c0 3.033 2.467 5.5 5.5 5.5m-1.5-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m.27 1.583a.626.626 0 0 1 .932.834A3.63 3.63 0 0 1 12 15.125a3.63 3.63 0 0 1-2.698-1.204.625.625 0 0 1 .93-.835c.901 1.003 2.639 1.003 3.538-.003"/></svg>`
    }, props, {
        newIcon: $4302e071af14b636$var$_emoji.default
    }));
$4302e071af14b636$var$EditorEmojiIcon.displayName = 'EditorEmojiIcon';
var $4302e071af14b636$var$_default = module.exports.default = $4302e071af14b636$var$EditorEmojiIcon;

});


parcelRegister("hibqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $45a9f9f50cdbc541$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $2l0ub = parcelRequire("2l0ub");

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");
var $9Egzu = parcelRequire("9Egzu");

var $l4haf = parcelRequire("l4haf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $45a9f9f50cdbc541$var$EmojiNode extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'EmojiNode';
    }
    static{
        this.defaultProps = {
            showTooltip: true
        };
    }
    constructor(props){
        super(props), this.renderWithProvider = (providers)=>{
            const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig } = this.props;
            if (allowTextFallback && !providers.emojiProvider) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                "data-emoji-id": id,
                "data-emoji-short-name": shortName,
                "data-emoji-text": fallback || shortName
            }, fallback || shortName);
            if (!providers.emojiProvider) return null;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2l0ub.default), {
                emojiId: {
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                },
                emojiProvider: providers.emojiProvider,
                showTooltip: showTooltip,
                fitToHeight: fitToHeight,
                optimistic: true,
                optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                }),
                editorEmoji: true
            });
        };
        this.providerFactory = props.providers || new (0, $dGzaM.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Egzu.WithProviders), {
            providers: [
                'emojiProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}
function $45a9f9f50cdbc541$var$EmojiItem(props) {
    const { id: id, providers: providers, shortName: shortName, text: text, fitToHeight: fitToHeight, resourceConfig: resourceConfig } = props;
    const inlineAnnotationProps = (0, $l4haf.useInlineAnnotationProps)(props);
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", inlineAnnotationProps, /*#__PURE__*/ (0, $f8Sb3.jsx)($45a9f9f50cdbc541$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        resourceConfig: resourceConfig
    })));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($45a9f9f50cdbc541$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        resourceConfig: resourceConfig
    });
}
// Working around an issue with pre existing tests using react-test-renderer
// https://github.com/facebook/react/issues/17301#issuecomment-557765213
$45a9f9f50cdbc541$var$EmojiItem.defaultProps = {};
var $45a9f9f50cdbc541$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($45a9f9f50cdbc541$var$EmojiItem);

});
parcelRegister("2l0ub", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dfb11fb8acb3045$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cC0Yc = parcelRequire("cC0Yc");

var $jagXT = parcelRequire("jagXT");

var $d2UcN = parcelRequire("d2UcN");

var $kin1Z = parcelRequire("kin1Z");
const $1dfb11fb8acb3045$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $5uXOq.useEffect)(()=>{
        if (!emojiId) return;
        (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $kin1Z.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $d2UcN.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jagXT.UfoErrorBoundary), {
        experiences: [
            (0, $d2UcN.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cC0Yc.ResourcedEmojiComponent), {
            ...props
        })
    });
};
var $1dfb11fb8acb3045$export$2e2bcd8739ae039 = $1dfb11fb8acb3045$var$ResourcedEmoji;

});
parcelRegister("cC0Yc", function(module, exports) {

$parcel$export(module.exports, "ResourcedEmojiComponent", () => $7e04d51fabd85670$export$7bfde52eceb3e2f6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bFU4G = parcelRequire("bFU4G");

var $kin1Z = parcelRequire("kin1Z");

var $5B9Cy = parcelRequire("5B9Cy");

var $9AR2K = parcelRequire("9AR2K");

var $7LZcH = parcelRequire("7LZcH");

var $kAeq1 = parcelRequire("kAeq1");

var $d2UcN = parcelRequire("d2UcN");

var $fIUtB = parcelRequire("fIUtB");

var $d2UcN = parcelRequire("d2UcN");
var $7e04d51fabd85670$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($7e04d51fabd85670$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $7e04d51fabd85670$export$7bfde52eceb3e2f6 = (props)=>{
    const { emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $kin1Z.defaultEmojiHeight), optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji } = props;
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $5uXOq.useState)();
    const [loaded, setLoaded] = (0, $5uXOq.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $5uXOq.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $5uXOq.useState)();
    const getActiveInterationMetadata = ()=>{
        const activeInteraction = (0, $bFU4G.getActiveInteraction)();
        let activeInteractionMetadata = {};
        if (activeInteraction) activeInteractionMetadata = {
            ...activeInteraction.metaData['productInteractionName'] ? {
                productInteractionName: activeInteraction.metaData['productInteractionName']
            } : {},
            ...activeInteraction.metaData['productInteractionType'] ? {
                productInteractionType: activeInteraction.metaData['productInteractionType']
            } : {}
        };
        return activeInteractionMetadata;
    };
    const fetchOrGetEmoji = (0, $5uXOq.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            const activeInteractionMetadata = getActiveInterationMetadata();
            setEmoji(undefined);
            (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: 'missing fetchByEmojiId interface',
                    source: 'ResourcedEmojiComponent',
                    ...activeInteractionMetadata
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch);
        (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).mark((0, $9AR2K.UfoEmojiTimings).METADATA_START);
        if ((0, $5B9Cy.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    // emoji is undefined
                    const activeInteractionMetadata = getActiveInterationMetadata();
                    (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: 'failed to find',
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            },
                            ...activeInteractionMetadata
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const activeInteractionMetadata = getActiveInterationMetadata();
                (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: 'failed to load',
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        },
                        ...activeInteractionMetadata
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).mark((0, $9AR2K.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).mark((0, $9AR2K.UfoEmojiTimings).METADATA_END);
        }
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $d2UcN.hasUfoMarked)((0, $d2UcN.sampledUfoRenderedEmoji)(emojiId), (0, $9AR2K.UfoEmojiTimings).FMP_END)) (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
	 * Setting resolved emoji provider for optimistic rendering
	 */ (0, $5uXOq.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $5uXOq.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $5uXOq.useMemo)(()=>{
        if (optimisticImageURL) {
            if (emoji && ((0, $5B9Cy.isImageRepresentation)(emoji.representation) || (0, $5B9Cy.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $kin1Z.defaultEmojiHeight),
                    width: fitToHeight || (0, $kin1Z.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName
    ]);
    const handleOnLoadError = (0, $5uXOq.useCallback)((emojiId)=>{
        const activeInteractionMetadata = getActiveInterationMetadata();
        setImageLoadError(true);
        (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id,
                ...activeInteractionMetadata
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fIUtB.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            "data-emoji-id": id,
            "data-emoji-short-name": shortName,
            "data-emoji-text": fallback || shortName,
            children: [
                emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kAeq1.default), {
                    shortName: shortName,
                    showTooltip: showTooltip,
                    size: fitToHeight || (0, $kin1Z.defaultEmojiHeight),
                    loading: true
                }),
                emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: customFallback || fallback || shortName
                }),
                emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7LZcH.default), {
                    emoji: optimisticEmojiDescription,
                    onLoadError: handleOnLoadError,
                    showTooltip: showTooltip,
                    fitToHeight: fitToHeight,
                    autoWidth: !!emoji ? false : true,
                    editorEmoji: editorEmoji
                })
            ]
        })
    });
};
var $7e04d51fabd85670$export$2e2bcd8739ae039 = $7e04d51fabd85670$export$7bfde52eceb3e2f6;

});
parcelRegister("kin1Z", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $1c1f8a5ed290c232$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $1c1f8a5ed290c232$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $1c1f8a5ed290c232$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $1c1f8a5ed290c232$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $1c1f8a5ed290c232$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $1c1f8a5ed290c232$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $1c1f8a5ed290c232$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $1c1f8a5ed290c232$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $1c1f8a5ed290c232$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $1c1f8a5ed290c232$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $1c1f8a5ed290c232$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $1c1f8a5ed290c232$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $1c1f8a5ed290c232$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $1c1f8a5ed290c232$export$7722b8e9522021df);
$parcel$export(module.exports, "localStoragePrefix", () => $1c1f8a5ed290c232$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $1c1f8a5ed290c232$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $1c1f8a5ed290c232$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $1c1f8a5ed290c232$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $1c1f8a5ed290c232$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $1c1f8a5ed290c232$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $1c1f8a5ed290c232$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $1c1f8a5ed290c232$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $1c1f8a5ed290c232$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $1c1f8a5ed290c232$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $1c1f8a5ed290c232$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $1c1f8a5ed290c232$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $1c1f8a5ed290c232$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $1c1f8a5ed290c232$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $1c1f8a5ed290c232$export$66cabad5e268b05e);
const $1c1f8a5ed290c232$export$5e4e3d1c3e43156a = 'CUSTOM';
const $1c1f8a5ed290c232$export$78ccdc4be403c468 = 'FREQUENT';
const $1c1f8a5ed290c232$export$2c4b04c3aacdf1b3 = 'SITE';
const $1c1f8a5ed290c232$export$1b0258512be88334 = 'SEARCH';
const $1c1f8a5ed290c232$export$42b510423367f354 = 'USER_CUSTOM';
const $1c1f8a5ed290c232$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $1c1f8a5ed290c232$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $1c1f8a5ed290c232$export$8ac325bfd32359b0 = 'data:';
const $1c1f8a5ed290c232$export$a330961542edfe6f = 'delete-emoji';
const $1c1f8a5ed290c232$export$1a817f1886276c6d = 100000;
const $1c1f8a5ed290c232$export$3f99ac31dc0406db = 20;
const $1c1f8a5ed290c232$export$d171dc12fee2b1da = 350;
const $1c1f8a5ed290c232$export$c10ac8125a260041 = 80;
const $1c1f8a5ed290c232$export$5248fb9e0cccc41f = 'medium';
const $1c1f8a5ed290c232$export$94f75d625e7801d3 = 260;
const $1c1f8a5ed290c232$export$7ed599d166d65aea = 295;
const $1c1f8a5ed290c232$export$7722b8e9522021df = $1c1f8a5ed290c232$export$7ed599d166d65aea - 58; // picker height - actions height
const $1c1f8a5ed290c232$export$e218e5cb105a0e22 = 54;
const $1c1f8a5ed290c232$export$e67f617938b111f1 = $1c1f8a5ed290c232$export$7ed599d166d65aea + $1c1f8a5ed290c232$export$e218e5cb105a0e22;
const $1c1f8a5ed290c232$export$e394a0c530ae5631 = 'fabric.emoji';
const $1c1f8a5ed290c232$export$79ee4ef84c545f8f = `${$1c1f8a5ed290c232$export$e394a0c530ae5631}.selectedTone`;
const $1c1f8a5ed290c232$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $1c1f8a5ed290c232$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $1c1f8a5ed290c232$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $1c1f8a5ed290c232$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $1c1f8a5ed290c232$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $1c1f8a5ed290c232$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $1c1f8a5ed290c232$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $1c1f8a5ed290c232$export$4f0ee90b28d6efc5 = 0;
const $1c1f8a5ed290c232$export$9f7de4293d27f3aa = 50;
const $1c1f8a5ed290c232$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $1c1f8a5ed290c232$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $1c1f8a5ed290c232$export$2829f3ec323f8ec0 = 8;
const $1c1f8a5ed290c232$export$ce3a0e7d2d7d6ba2 = 5;
const $1c1f8a5ed290c232$export$858e8dc100a97278 = 150;
const $1c1f8a5ed290c232$export$83aab2ae64548423 = 20;
const $1c1f8a5ed290c232$export$66cabad5e268b05e = 100;

});

parcelRegister("5B9Cy", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $fb1b6c003b1856ef$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $fb1b6c003b1856ef$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $fb1b6c003b1856ef$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $fb1b6c003b1856ef$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $fb1b6c003b1856ef$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $fb1b6c003b1856ef$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $fb1b6c003b1856ef$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $fb1b6c003b1856ef$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $fb1b6c003b1856ef$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $fb1b6c003b1856ef$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $fb1b6c003b1856ef$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $fb1b6c003b1856ef$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $fb1b6c003b1856ef$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $fb1b6c003b1856ef$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $fb1b6c003b1856ef$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $fb1b6c003b1856ef$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $fb1b6c003b1856ef$export$4bcbf61cb6832a8e);

var $aSE1r = parcelRequire("aSE1r");

var $kin1Z = parcelRequire("kin1Z");
const $fb1b6c003b1856ef$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $fb1b6c003b1856ef$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $fb1b6c003b1856ef$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $fb1b6c003b1856ef$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $fb1b6c003b1856ef$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $fb1b6c003b1856ef$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $fb1b6c003b1856ef$export$a7e82c67204c73a1 = (emoji)=>$fb1b6c003b1856ef$export$979133dc1df141c6(emoji.representation);
const $fb1b6c003b1856ef$export$7720a4954d6f75f8 = (rep)=>$fb1b6c003b1856ef$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $kin1Z.dataURLPrefix)) === 0;
const $fb1b6c003b1856ef$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $kin1Z.customCategory) && $fb1b6c003b1856ef$export$7720a4954d6f75f8(emoji.representation);
const $fb1b6c003b1856ef$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $fb1b6c003b1856ef$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $fb1b6c003b1856ef$export$dddfba07c16c94d2 = (key)=>key in (0, $aSE1r.messages);
const $fb1b6c003b1856ef$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $fb1b6c003b1856ef$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $fb1b6c003b1856ef$export$8d7d3de6b5b305d1(emoji);
};
const $fb1b6c003b1856ef$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $fb1b6c003b1856ef$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($fb1b6c003b1856ef$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $fb1b6c003b1856ef$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $fb1b6c003b1856ef$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $fb1b6c003b1856ef$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$fb1b6c003b1856ef$export$979133dc1df141c6(mediaRepresentation) && !$fb1b6c003b1856ef$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $fb1b6c003b1856ef$export$979133dc1df141c6(mediaRepresentation) ? $fb1b6c003b1856ef$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $fb1b6c003b1856ef$export$979133dc1df141c6(mediaAltRepresentation) ? $fb1b6c003b1856ef$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $fb1b6c003b1856ef$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $fb1b6c003b1856ef$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $fb1b6c003b1856ef$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("aSE1r", function(module, exports) {

$parcel$export(module.exports, "messages", () => $11d87ef7c2048740$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $11d87ef7c2048740$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    /*
	searchResultsStatus: {
		id: 'fabric.emoji.search.status',
		defaultMessage: 'Found {count} emojis',
		description: 'search results status for screenreader to read out',
	},
	 */ searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("9AR2K", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $d0b081d2572cc7bf$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $d0b081d2572cc7bf$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $d0b081d2572cc7bf$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $d0b081d2572cc7bf$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $d0b081d2572cc7bf$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $d0b081d2572cc7bf$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $d0b081d2572cc7bf$export$482549d945a3723);
var $d0b081d2572cc7bf$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $d0b081d2572cc7bf$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $d0b081d2572cc7bf$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $d0b081d2572cc7bf$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $d0b081d2572cc7bf$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $d0b081d2572cc7bf$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $d0b081d2572cc7bf$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("7LZcH", function(module, exports) {

$parcel$export(module.exports, "EmojiNodeWrapper", () => $e978b8e9836bc944$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $e978b8e9836bc944$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $0Bueq = parcelRequire("0Bueq");

var $kin1Z = parcelRequire("kin1Z");

var $5B9Cy = parcelRequire("5B9Cy");

var $9AR2K = parcelRequire("9AR2K");

var $6f82C = parcelRequire("6f82C");

var $8L6cL = parcelRequire("8L6cL");


var $d2UcN = parcelRequire("d2UcN");
var $d8gl8 = parcelRequire("d8gl8");

var $lsSGz = parcelRequire("lsSGz");

var $7zSof = parcelRequire("7zSof");

var $d2UcN = parcelRequire("d2UcN");

var $jtKZR = parcelRequire("jtKZR");

var $50JWu = parcelRequire("50JWu");
const $e978b8e9836bc944$var$emojiSpriteContainer = null;
const $e978b8e9836bc944$var$emojiImageContainer = null;
const $e978b8e9836bc944$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $kin1Z.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $6f82C.leftClick)(event)) onSelected((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
};
const $e978b8e9836bc944$var$handleKeyDown = (props, event)=>{
    if (!(0, $kin1Z.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $kin1Z.KeyboardKeys).Enter || event.key === (0, $kin1Z.KeyboardKeys).Space)) onSelected((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $kin1Z.KeyboardKeys).Backspace) $e978b8e9836bc944$var$handleDelete(props, event);
};
const $e978b8e9836bc944$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
};
const $e978b8e9836bc944$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
};
const $e978b8e9836bc944$var$handleDelete = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
};
const $e978b8e9836bc944$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
};
const $e978b8e9836bc944$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $63856011855bb785$export$b06c4aab1d012063)} ${selected ? (0, $63856011855bb785$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $63856011855bb785$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) sizing = {
        width: `${fitToHeight}px`,
        height: `${fitToHeight}px`,
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
    };
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($e978b8e9836bc944$export$ce5eef59d8e46687, {
        ...props,
        type: "sprite",
        className: classes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $63856011855bb785$export$1c10634420a08d8a),
            style: style
        })
    }));
};
const $e978b8e9836bc944$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $7zSof.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $d2UcN.sampledUfoRenderedEmoji)(emoji);
    const classes = `${(0, $63856011855bb785$export$11462c0756c24ab6)} ${(0, $63856011855bb785$export$b06c4aab1d012063)} ${selected ? (0, $63856011855bb785$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $63856011855bb785$export$860109dfd198259b) : ''} ${(0, $63856011855bb785$export$da61cef1c8919f7c)} ${className ? className : ''} ${showDelete ? (0, $63856011855bb785$export$22b19c311e9caa4) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $0Bueq.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $5B9Cy.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $5B9Cy.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) // Presize image, to prevent reflow due to size changes after loading
    sizing = {
        // Size of <img> needs to be deterministic when rendered on server-side. Auto will cause width to be 0 before image is loaded.
        width: autoWidth && !(0, $50JWu.isSSR)() ? 'auto' : fitToHeight / height * width,
        height: fitToHeight
    };
    const onError = (0, $5uXOq.useCallback)((event)=>{
        $e978b8e9836bc944$var$handleImageError(props, event);
    }, [
        props
    ]);
    const onLoad = (0, $5uXOq.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9AR2K.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $d2UcN.hasUfoMarked)(ufoExp, (0, $9AR2K.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9AR2K.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9AR2K.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $d2UcN.hasUfoMarked)(ufoExp, (0, $9AR2K.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $9AR2K.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $lsSGz.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $d2UcN.hasUfoMarked)(ufoExp, (0, $9AR2K.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9AR2K.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $5uXOq.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!document.activeElement?.contains(e.target)) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $5uXOq.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        //@ts-ignore
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        alt: emoji.name || emoji.shortName,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }, src);
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtKZR.DeletableEmojiTooltipContent), {}),
        position: "right-start",
        tag: "span",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)($e978b8e9836bc944$export$ce5eef59d8e46687, {
            ...props,
            "aria-labelledby": `screenreader-emoji-${emoji.id}`,
            type: "image",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: classes,
            ref: ref,
            showTooltip: false,
            onMouseOver: onMouseOver,
            children: [
                emojiNode,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8L6cL.default), {
                    onClick: (event)=>$e978b8e9836bc944$var$handleDelete(props, event)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtKZR.DeletableEmojiTooltipContentForScreenReader), {
                    emoji: emoji
                })
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($e978b8e9836bc944$export$ce5eef59d8e46687, {
        ...props,
        type: "image",
        className: classes,
        ref: ref,
        children: emojiNode
    }));
};
const $e978b8e9836bc944$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
    let accessibilityProps;
    if (editorEmoji) accessibilityProps = {
        role: undefined
    };
    else if (shouldBeInteractive) accessibilityProps = {
        role: 'button',
        'aria-label': emoji.shortName
    };
    else accessibilityProps = {
        role: 'img',
        'aria-label': emoji.shortName
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...accessibilityProps,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50scvx _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j14ae _3naf14ae _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc" : "_2rkosqtm _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk18uv _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j14ae _3naf14ae _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc",
            className
        ]),
        onKeyDown: (event)=>$e978b8e9836bc944$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $e978b8e9836bc944$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $e978b8e9836bc944$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $e978b8e9836bc944$var$handleFocus(props, event);
        },
        title: showTooltip ? emoji.shortName : undefined,
        ...other,
        children: children
    });
});
const $e978b8e9836bc944$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $d8gl8.useSampledUFOComponentExperience)((0, $d2UcN.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $kin1Z.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $5uXOq.useEffect)(()=>{
        const ufoExp = (0, $d2UcN.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $d2UcN.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $d2UcN.hasUfoMarked)(ufoExp, (0, $9AR2K.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $9AR2K.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $5B9Cy.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $2OMIu.jsx)($e978b8e9836bc944$export$ef49ddbb198ce334, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e978b8e9836bc944$export$99dfeb9d71c11788, {
        ...props
    });
};
var $e978b8e9836bc944$export$2e2bcd8739ae039 = $e978b8e9836bc944$export$56cc48506ff790a;

});
parcelRegister("0Bueq", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $9b95bf1aff58b644$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $9b95bf1aff58b644$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $9b95bf1aff58b644$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $9b95bf1aff58b644$export$b7e9058f156d8d19);

var $dS9cn = parcelRequire("dS9cn");

var $5B9Cy = parcelRequire("5B9Cy");

var $b8sgr = parcelRequire("b8sgr");
const $9b95bf1aff58b644$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $9b95bf1aff58b644$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $9b95bf1aff58b644$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $dS9cn.utils).requestService(serviceConfig, requestOptions);
};
const $9b95bf1aff58b644$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $9b95bf1aff58b644$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $9b95bf1aff58b644$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$9b95bf1aff58b644$var$calculateScale($9b95bf1aff58b644$export$d39ce20a37bba061).altScale];
};
const $9b95bf1aff58b644$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $9b95bf1aff58b644$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $5B9Cy.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $5B9Cy.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($9b95bf1aff58b644$export$db05e6ae1fd416af(imagePath, meta)) return (0, $5B9Cy.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $b8sgr.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $9b95bf1aff58b644$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $9b95bf1aff58b644$export$55077db3efc820aa($9b95bf1aff58b644$export$4a0301d636367e1d(altReps), meta);
};
const $9b95bf1aff58b644$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $9b95bf1aff58b644$export$55077db3efc820aa(representation, meta),
            altRepresentation: $9b95bf1aff58b644$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $9b95bf1aff58b644$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $9b95bf1aff58b644$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $9b95bf1aff58b644$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $9b95bf1aff58b644$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $5B9Cy.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $9b95bf1aff58b644$var$getHeight = (fitToHeight)=>$9b95bf1aff58b644$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $9b95bf1aff58b644$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $9b95bf1aff58b644$var$getHeight(fitToHeight) > emoji.representation.height);

});
parcelRegister("b8sgr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b76154abb8f2c59$export$2e2bcd8739ae039);
let $1b76154abb8f2c59$var$debugEnabled = false;
let $1b76154abb8f2c59$var$stacktracesEnabled = false;
function $1b76154abb8f2c59$export$748ada60eaf985cc(enable) {
    $1b76154abb8f2c59$var$debugEnabled = enable;
}
function $1b76154abb8f2c59$export$4f7017086af31c25(enable) {
    $1b76154abb8f2c59$var$stacktracesEnabled = enable;
}
function $1b76154abb8f2c59$export$2a858f450a2f66d() {
    if ($1b76154abb8f2c59$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $1b76154abb8f2c59$export$2e2bcd8739ae039(msg, ...args) {
    if ($1b76154abb8f2c59$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});


parcelRegister("6f82C", function(module, exports) {

$parcel$export(module.exports, "leftClick", () => $4e45da7e67a9a10d$export$34ebdaf2c517ae75);
function $4e45da7e67a9a10d$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $4e45da7e67a9a10d$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $4e45da7e67a9a10d$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("8L6cL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebae65259713fbe9$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $7uxj1 = parcelRequire("7uxj1");


var $kin1Z = parcelRequire("kin1Z");


var $MHKc7 = parcelRequire("MHKc7");
const $ebae65259713fbe9$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $ebae65259713fbe9$var$deleteButton = null;
const $ebae65259713fbe9$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $ebae65259713fbe9$var$DeleteButton = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            (0, $63856011855bb785$export$b11fa39b56a371f6)
        ]),
        "data-testid": $ebae65259713fbe9$export$28fc7374cf1206d4,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $ebae65259713fbe9$var$styles.boxWrapperStyle,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7uxj1))), {
                    label: (0, $kin1Z.deleteEmojiLabel),
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
                    LEGACY_size: "small"
                })
            }),
            onClick: props.onClick,
            // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
            appearance: "subtle-link",
            spacing: "none",
            testId: "emoji-delete-button",
            tabIndex: -1
        })
    });
var $ebae65259713fbe9$export$2e2bcd8739ae039 = $ebae65259713fbe9$var$DeleteButton;

});
parcelRegister("7uxj1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23abdef56045225c72ffa19368031ad5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57452b9b34160439$var$_react = $57452b9b34160439$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $57452b9b34160439$var$_crossCircle = $57452b9b34160439$var$_interopRequireDefault((parcelRequire("47etd")));

var $57452b9b34160439$var$_crossCircle2 = $57452b9b34160439$var$_interopRequireDefault((parcelRequire("d5Zn3")));
function $57452b9b34160439$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "CrossCircleIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57452b9b34160439$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $57452b9b34160439$var$_react.default.createElement($57452b9b34160439$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $57452b9b34160439$var$_crossCircle2.default
    }, props));
$57452b9b34160439$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $57452b9b34160439$var$_default = module.exports.default = $57452b9b34160439$var$CrossCircleIcon;

});

var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("d2UcN", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $350e11372b641899$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $350e11372b641899$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $350e11372b641899$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $350e11372b641899$export$1466212a1606133);

var $9AR2K = parcelRequire("9AR2K");

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
var $boHLC = parcelRequire("boHLC");

var $bHWpv = parcelRequire("bHWpv");
const $350e11372b641899$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $7Zbvr.ExperienceTypes).Load,
        performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $350e11372b641899$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $7Zbvr.ExperienceTypes).Experience,
        performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
    };
};
const $350e11372b641899$var$customEmojiTimings = [
    {
        key: (0, $9AR2K.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $9AR2K.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $9AR2K.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $9AR2K.UfoEmojiTimings).METADATA_START,
        endMark: (0, $9AR2K.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $9AR2K.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $9AR2K.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $9AR2K.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $9AR2K.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $9AR2K.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $9AR2K.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $9AR2K.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $9AR2K.UfoEmojiTimings).ONLOAD_END
    }
];
const $350e11372b641899$export$615f888019c45765 = {
    'emoji-rendered': new (0, $cBycP.ConcurrentExperience)((0, $9AR2K.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $9AR2K.UfoComponentName).EMOJI
        },
        type: (0, $7Zbvr.ExperienceTypes).Operation,
        performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).Custom,
        timings: $350e11372b641899$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $cBycP.ConcurrentExperience)((0, $9AR2K.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $350e11372b641899$var$createRenderExperience((0, $9AR2K.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $boHLC.UFOExperience)((0, $9AR2K.UfoExperienceName).EMOJI_PICKER_OPENED, $350e11372b641899$var$createRenderExperience((0, $9AR2K.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $boHLC.UFOExperience)((0, $9AR2K.UfoExperienceName).EMOJI_SELECTION_RECORDED, $350e11372b641899$var$createInlineExperience((0, $9AR2K.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $boHLC.UFOExperience)((0, $9AR2K.UfoExperienceName).EMOJI_UPLOADED, $350e11372b641899$var$createInlineExperience((0, $9AR2K.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $boHLC.UFOExperience)((0, $9AR2K.UfoExperienceName).EMOJI_SEARCHED, $350e11372b641899$var$createInlineExperience((0, $9AR2K.UfoComponentName).EMOJI_PICKER))
};
const $350e11372b641899$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $bHWpv.withSampling)($350e11372b641899$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $350e11372b641899$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $350e11372b641899$export$1466212a1606133 = (providerType)=>{
    return (0, $bHWpv.withSampling)($350e11372b641899$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("cBycP", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);

var $dCAsn = parcelRequire("dCAsn");

var $boHLC = parcelRequire("boHLC");
class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $boHLC.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $dCAsn.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});

parcelRegister("bHWpv", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $8c8d9cbeece0ed73$export$dc2f0946255b3f89);
const $8c8d9cbeece0ed73$export$c7c4959fece2f3ec = {};
const $8c8d9cbeece0ed73$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($8c8d9cbeece0ed73$export$c7c4959fece2f3ec))delete $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[prop];
};
const $8c8d9cbeece0ed73$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $8c8d9cbeece0ed73$var$hasSampledFromStart = (experience)=>{
    if (!$8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $8c8d9cbeece0ed73$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id]) $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $8c8d9cbeece0ed73$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("d8gl8", function(module, exports) {

$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $56723850686121aa$export$f959821a7419dee1);

var $5uXOq = parcelRequire("5uXOq");

var $bHWpv = parcelRequire("bHWpv");
const $56723850686121aa$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $56723850686121aa$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            (0, $bHWpv.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $56723850686121aa$var$useConstructor(()=>{
        (0, $bHWpv.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("lsSGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b352fff4283dbda5$export$2e2bcd8739ae039);
const $b352fff4283dbda5$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $b352fff4283dbda5$var$result.mac = /Mac/.test(navigator.platform);
    $b352fff4283dbda5$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $b352fff4283dbda5$export$2e2bcd8739ae039 = $b352fff4283dbda5$var$result;

});

parcelRegister("7zSof", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $58303c715e6c41b6$export$2f62ee6831462844);

var $6ggyj = parcelRequire("6ggyj");

var $lsSGz = parcelRequire("lsSGz");
const $58303c715e6c41b6$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $6ggyj.useInView)(options);
    if (!(0, $lsSGz.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("6ggyj", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $48f113a7cf9419a6$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $48f113a7cf9419a6$var$_extends() {
    $48f113a7cf9419a6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48f113a7cf9419a6$var$_extends.apply(this, arguments);
}
function $48f113a7cf9419a6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $48f113a7cf9419a6$var$_setPrototypeOf(subClass, superClass);
}
function $48f113a7cf9419a6$var$_setPrototypeOf(o, p) {
    $48f113a7cf9419a6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $48f113a7cf9419a6$var$_setPrototypeOf(o, p);
}
function $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $48f113a7cf9419a6$var$observerMap = new Map();
var $48f113a7cf9419a6$var$RootIds = new WeakMap();
var $48f113a7cf9419a6$var$rootId = 0;
var $48f113a7cf9419a6$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $48f113a7cf9419a6$export$2ef3a60ee1f37bec(inView) {
    $48f113a7cf9419a6$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $48f113a7cf9419a6$var$getRootId(root) {
    if (!root) return '0';
    if ($48f113a7cf9419a6$var$RootIds.has(root)) return $48f113a7cf9419a6$var$RootIds.get(root);
    $48f113a7cf9419a6$var$rootId += 1;
    $48f113a7cf9419a6$var$RootIds.set(root, $48f113a7cf9419a6$var$rootId.toString());
    return $48f113a7cf9419a6$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $48f113a7cf9419a6$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? $48f113a7cf9419a6$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $48f113a7cf9419a6$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $48f113a7cf9419a6$var$optionsToId(options);
    var instance = $48f113a7cf9419a6$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $48f113a7cf9419a6$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $48f113a7cf9419a6$export$d1203567a167490e(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = $48f113a7cf9419a6$var$unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    } // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $48f113a7cf9419a6$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $48f113a7cf9419a6$var$observerMap["delete"](id);
        }
    };
}
var $48f113a7cf9419a6$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $48f113a7cf9419a6$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var $48f113a7cf9419a6$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $48f113a7cf9419a6$var$_inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!$48f113a7cf9419a6$var$isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = $48f113a7cf9419a6$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!$48f113a7cf9419a6$var$isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(_this$props2, $48f113a7cf9419a6$var$_excluded);
        return /*#__PURE__*/ $5uXOq.createElement(as || 'div', $48f113a7cf9419a6$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}($5uXOq.Component);
$48f113a7cf9419a6$export$a62107ca74432f44.displayName = 'InView';
$48f113a7cf9419a6$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false,
    initialInView: false
};
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $48f113a7cf9419a6$export$2f62ee6831462844(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
    var unobserve = $5uXOq.useRef();
    var _React$useState = $5uXOq.useState({
        inView: !!initialInView
    }), state = _React$useState[0], setState = _React$useState[1];
    var setRef = $5uXOq.useCallback(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        } // Skip creating the observer
        if (skip) return;
        if (node) unobserve.current = $48f113a7cf9419a6$export$d1203567a167490e(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    /* eslint-disable-next-line */ (0, $5uXOq.useEffect)(function() {
        if (!unobserve.current && state.entry && !triggerOnce && !skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState({
            inView: !!initialInView
        });
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});


parcelRegister("jtKZR", function(module, exports) {

$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $1932ba1320ae3825$export$4727956877b6f612);
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $1932ba1320ae3825$export$d151e4941072147c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $aSE1r = parcelRequire("aSE1r");

var $bjlYp = parcelRequire("bjlYp");

var $cH8IX = parcelRequire("cH8IX");

var $jldZL = parcelRequire("jldZL");
const $1932ba1320ae3825$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bjlYp.ToolTipContentWithKeymap), {
        description: formatMessage((0, $aSE1r.messages).deleteEmojiTooltip),
        keymap: (0, $cH8IX.backspace)
    });
};
const $1932ba1320ae3825$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
        id: `screenreader-emoji-${emoji.id}`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $aSE1r.messages).deleteEmojiTooltipForScreenreader,
            values: {
                shortName: emoji.shortName
            }
        })
    });
};

});
parcelRegister("bjlYp", function(module, exports) {

$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $bf61861434f5a860$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cH8IX = parcelRequire("cH8IX");
const $bf61861434f5a860$var$tooltipShortcutStyle = null;
const $bf61861434f5a860$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $cH8IX.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            description,
            shortcut && description && '\u00A0',
            shortcut && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_2rko1l7b _bfhk17rn _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
                ]),
                children: shortcut
            })
        ]
    }) : null;
});

});
parcelRegister("cH8IX", function(module, exports) {

$parcel$export(module.exports, "backspace", () => $8c801b5eb0fedf3e$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "formatShortcut", () => $8c801b5eb0fedf3e$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $lsSGz = parcelRequire("lsSGz");
const $8c801b5eb0fedf3e$export$1ea584ca7009bcc1 = $8c801b5eb0fedf3e$export$7e6b588cc98b34f1('Backspace', 'Backspace');
function $8c801b5eb0fedf3e$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $8c801b5eb0fedf3e$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $8c801b5eb0fedf3e$export$d8a7f422d8d42038(description, windows, mac, common);
}
const $8c801b5eb0fedf3e$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
function $8c801b5eb0fedf3e$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $lsSGz.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $8c801b5eb0fedf3e$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $lsSGz.default).mac ? '' : '+');
}

});



parcelRegister("50JWu", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $ea1a71963de9abbf$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $ea1a71963de9abbf$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && $6cAn5?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("kAeq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b03b8ed1cdbc30$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $kin1Z = parcelRequire("kin1Z");

const $e3b03b8ed1cdbc30$var$placeholderContainer = null;
const $e3b03b8ed1cdbc30$var$easeSweep = null;
const $e3b03b8ed1cdbc30$var$placeholderContainerAnimated = null;
const $e3b03b8ed1cdbc30$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
const $e3b03b8ed1cdbc30$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $kin1Z.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": $e3b03b8ed1cdbc30$export$73987987fac5266b(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkosqtm _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhkttw1 _s7n4nkob _o5721q9c _y3gn1h6o",
            loading && !(0, $VSDnB.fg)('cc_complexit_fe_remove_emoji_animation') && "",
            loading && !(0, $VSDnB.fg)('cc_complexit_fe_remove_emoji_animation') && "_16qq1t1r _1kt9b3bt _cfu11ule _1cs8stnw _1rusiw92 _kfgt1osq _1mp41osq",
            (0, $63856011855bb785$export$c7187bbd1a7a9244)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $e3b03b8ed1cdbc30$export$2e2bcd8739ae039 = $e3b03b8ed1cdbc30$var$EmojiPlaceholder;

});

parcelRegister("fIUtB", function(module, exports) {

$parcel$export(module.exports, "EmojiCommonProvider", () => $bccbd11b1b65c6ff$export$1120e666998e21b5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jXu3z = parcelRequire("jXu3z");
const $bccbd11b1b65c6ff$export$1120e666998e21b5 = (props)=>{
    if (props.emojiProvider) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jXu3z.EmojiContextProvider), {
        emojiContextValue: {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        },
        children: props.children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: props.children
    });
};

});
parcelRegister("jXu3z", function(module, exports) {

$parcel$export(module.exports, "EmojiContextProvider", () => $13463f47d01f8908$export$f4a09143833145ed);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hXj7Q = parcelRequire("hXj7Q");

var $b8sgr = parcelRequire("b8sgr");
const $13463f47d01f8908$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $5uXOq.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $b8sgr.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hXj7Q.EmojiContext).Provider, {
        value: memoizedEmojiContextValue,
        children: children
    });
};

});
parcelRegister("hXj7Q", function(module, exports) {

$parcel$export(module.exports, "EmojiContext", () => $328171771ca4c781$export$9fab6c37a453c65e);

var $5uXOq = parcelRequire("5uXOq");
const $328171771ca4c781$export$9fab6c37a453c65e = (0, $5uXOq.createContext)(null);

});




parcelRegister("jagXT", function(module, exports) {

$parcel$export(module.exports, "UfoErrorBoundary", () => $e764d90a3b7c2797$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");
class $e764d90a3b7c2797$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("l4haf", function(module, exports) {

$parcel$export(module.exports, "useInlineAnnotationProps", () => $d0388e6a4f35db6c$export$11564cda945bb3c9);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $iYAgE = parcelRequire("iYAgE");
function $d0388e6a4f35db6c$export$11564cda945bb3c9(props) {
    const draftPosition = (0, $5uXOq.useContext)((0, $iYAgE.AnnotationsDraftContext));
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}

});


parcelRegister("f5KSA", function(module, exports) {

$parcel$export(module.exports, "PanelErrorIcon", () => $96b527f94a403c7a$export$76fa6c311f4e2871);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $96b527f94a403c7a$var$PanelErrorGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $96b527f94a403c7a$export$76fa6c311f4e2871 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $96b527f94a403c7a$var$PanelErrorGlyph,
        ...props
    });
};

});

parcelRegister("eaR7m", function(module, exports) {

$parcel$export(module.exports, "PanelInfoIcon", () => $d91e73a67b7d2b96$export$2187dc2d495c3efc);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $d91e73a67b7d2b96$var$PanelInfoGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $d91e73a67b7d2b96$export$2187dc2d495c3efc = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $d91e73a67b7d2b96$var$PanelInfoGlyph,
        ...props
    });
};

});

parcelRegister("5AmZK", function(module, exports) {

$parcel$export(module.exports, "PanelNoteIcon", () => $6bc8798a62855fe1$export$d4f894f0c3f0db6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $6bc8798a62855fe1$var$PanelNoteGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $6bc8798a62855fe1$export$d4f894f0c3f0db6 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $6bc8798a62855fe1$var$PanelNoteGlyph,
        ...props
    });
};

});

parcelRegister("fIRKG", function(module, exports) {

$parcel$export(module.exports, "PanelSuccessIcon", () => $442ba659e5a389a4$export$a5a5162e21242c3c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $442ba659e5a389a4$var$PanelSuccessGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $442ba659e5a389a4$export$a5a5162e21242c3c = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $442ba659e5a389a4$var$PanelSuccessGlyph,
        ...props
    });
};

});

parcelRegister("j9muy", function(module, exports) {

$parcel$export(module.exports, "PanelWarningIcon", () => $a15778b28bcee665$export$246c5468186717b7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $a15778b28bcee665$var$PanelWarningGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $a15778b28bcee665$export$246c5468186717b7 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $a15778b28bcee665$var$PanelWarningGlyph,
        ...props
    });
};

});



//# sourceMappingURL=panel.555f011f.js.map
